/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_New_ToolsInputs */

const en_directory_launch_new_tools = /** @type {(inputs: Directory_Launch_New_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New tools`)
};

const zh_directory_launch_new_tools = /** @type {(inputs: Directory_Launch_New_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新工具`)
};

/**
* | output |
* | --- |
* | "New tools" |
*
* @param {Directory_Launch_New_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_new_tools = /** @type {((inputs?: Directory_Launch_New_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_New_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_new_tools(inputs)
	return zh_directory_launch_new_tools(inputs)
});
export { directory_launch_new_tools as "directory.launch.new_tools" }